import { createStore } from 'vuex'
import axios from 'axios'
// import router from '../router'

export const bannerCode = {
  bnrRgstTxt: 'banner-register-plain',
  bnrRgstHtml: 'banner-register-html',
  bnrHomeNoKta: 'banner-home-non-kta',
  bnrHomeNoKtaMobile: 'banner-home-non-kta-mobile',
  bnrHomeOldKta: 'banner-home-old-kta',
  bnrHomeOldKtaMobile: 'banner-home-old-kta-mobile',
  bnrHomeActvKta: 'banner-home-active-kta',
  bnrHomeActvKtaMobile: 'banner-home-active-kta-mobile',
  bnrKtaSideHtml1: 'banner-kta-sidebar-html-1',
  bnrKtaSideTxt1: 'banner-kta-sidebar-plain-1',
  bnrKtaSideHtml2: 'banner-kta-sidebar-html-2',
  bnrKtaSideTxt2: 'banner-kta-sidebar-plain-2',
  bnrKtaSuccessRgstHtml: 'banner-kta-success-html',
  bnrKtaSuccessRgstTxt: 'banner-kta-success-plain',
  bnrDetailBenefitHtml: 'banner-detail-benefit-html',
  bnrDetailBenefitTxt: 'banner-detail-benefit-plain'
}

export default createStore({
  state: {
    isShowCard: false,
    isShowCardPolls: false,
    token: '',
    isLogin: false,
    profile: null,
    alertMessage: 'Something went wrong!',
    showAlert: false,
    alertType: 'failed',
    alertCallback: () => {},
    notification: [],
    livestream: [],
    page: 1,
    showDocumentHighlight: false,
    pollUrl: '',

    // alert
    globalAlertShow: false,
    globalAlertMessage: '',
    globalAlertType: 'info', // info | dark | danger | warning | success
    globalAlertDuration: 3000, // ms
    globalAlertPosition: 'top-center' // top-center | top-right | top-left
  },
  mutations: {
    setCardIsShow (state, payload) {
      state.isShowCard = payload
    },
    setPollsCardIsShow (state, payload) {
      state.isShowCardPolls = payload
    },
    setToken (state, payload) {
      state.token = payload
    },
    setIsLogin (state, payload) {
      state.isLogin = payload
    },
    setProfile (state, payload) {
      state.profile = payload
    },
    setPollUrl (state, payload) {
      state.pollUrl = payload
    },
    setShowAlert (state, payload) {
      state.showAlert = payload
    },
    setAlertMessage (state, payload) {
      state.alertMessage = payload
    },
    setAlertType (state, payload) {
      state.alertType = payload
    },
    setAlertCallback (state, payload) {
      state.alertCallback = payload
    },
    setNotification (state, payload) {
      state.notification = payload
    },
    setLivestream (state, payload) {
      state.livestream = payload
    },
    setPage (state, payload) {
      state.page = payload
    },
    setDocumentHighlight (state, payload) {
      state.showDocumentHighlight = payload
    },

    // alert methods
    showGlobalAlert (state, payload) {
      state.globalAlertShow = true
      state.globalAlertMessage = payload.message
      state.globalAlertType = payload.type || 'info'
      state.globalAlertDuration = payload.duration ?? 3000
      state.globalAlertPosition = payload.position || 'top-center'
    },
    hideGlobalAlert (state) {
      state.globalAlertShow = false
    }
  },
  actions: {
    async verToken ({ commit, state, dispatch }) {
      try {
        const authToken = await axios.get(`${process.env.VUE_APP_API_URL}auth/auth?token=${state.token}`)
        if (authToken.status === 200) {
          commit('setIsLogin', true)
        }
      } catch (err) {
        commit('setIsLogin', false)
      }
    },
    async getProfile ({ commit, state }) {
      try {
        const profile = await axios.get('member/profile')
        commit('setProfile', profile.data?.data)
      } catch (err) {
      }
    },
    async resetPage ({ commit }, { page = 1 }) {
      commit('setPage', page)
    },
    async getNotificationList ({ commit, state, getters }, { type, limit = 10 }) {
      const params = {
        limit,
        page: state.page,
        content_type: type
      }
      const response = await axios.get('notification/notification/listnotification', { params })
      const prevNotification = [...new Map(getters.getNotificationList.map(v => [v.notification_id, v])).values()]

      // if page is 1 and no notification return empty array instead of null

      if (params.page === 1 && !response.data.data) {
        return commit('setNotification', [])
      }

      // Don't increment params page if there is no more notification
      if (!response.data.data) {
        return commit('setPage', params.page)
      }

      // don't increment page if there is less than 10 notification
      if (response.data.data.length < 10) {
        commit('setPage', params.page)
      } else {
        commit('setPage', params.page + 1)
      }

      if (params.page > 1) {
        // remove previous notification that less than 10
        let newOldNotif = []
        if (!prevNotification.length % 10 === 0) {
          newOldNotif = prevNotification.slice(0, prevNotification.length - prevNotification.length % limit)
        } else {
          newOldNotif = prevNotification
        }
        commit('setNotification', [...newOldNotif, ...response.data.data])
      } else {
        commit('setNotification', response.data.data)
      }
    },
    async getLivestream ({ commit, state }) {
      const response = await axios.get('content/activelivestreaming')
      if (response.data.data) {
        commit('setLivestream', [{
          ...response.data.data,
          content_type: 'live'
        }])
      } else {
        commit('setLivestream', [])
      }
    },

    async getBanners ({}, code) {
      const res = await axios.get('member/banner?code=' + code)
      return res.data
    },

    async activateBenefit ({ state }) {
      const res = await axios.post('member/activate-benefits', { headers: { Authorization: `Bearer ${state.token}` } })
      return res.data
    }
  },
  modules: {
  },
  getters: {
    getProfile: state => state.profile,
    getMyState: state => state.isShowCard,
    getAlertMessage: state => state.alertMessage,
    getAlertState: state => state.showAlert,
    getAlertType: state => state.alertType,
    getAlertCallback: state => state.alertCallback,
    getStatePollsCard: state => state.isShowCardPolls,
    getNotification: state => state.notification,
    getLivestream: state => state.livestream,
    getNotificationList: state => state.notification,
    getDocumentHighlight: state => state.showDocumentHighlight,
    getPollUrl: state => state.pollUrl,

    // alert
    getGlobalAlertState: state => state.globalAlertShow,
    getGlobalAlertMessage: state => state.globalAlertMessage,
    getGlobalAlertType: state => state.globalAlertType,
    getGlobalAlertDuration: state => state.globalAlertDuration,
    getGlobalAlertPosition: state => state.globalAlertPosition
  }
})
